// Types
import { PERMISION } from "security"
import type { MenuType } from "../types"

export const analyticsMenu = {
  menu: [
    {
      label: "8 KEYS",
      link: "/analytics/8-keys",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "FINANCE",
      link: "/analytics/finance",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "SALES",
      link: "/analytics/sales",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "PURCHASES",
      link: "/analytics/purchases",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "INVENTORY",
      link: "/analytics/inventory",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "CUSTOMERS",
      link: "/analytics/customers",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "VENDORS",
      link: "/analytics/vendors",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "EMPLOYEE",
      link: "/analytics/employee",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "MARKETING",
      link: "/analytics/marketing",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "PRODUCTION",
      link: "/analytics/production",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "RETAIL",
      link: "/analytics/retail",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "WAREHOUSE",
      link: "/analytics/warehouse",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "LOCATIONS",
      link: "/analytics/locations",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "PROJECT",
      link: "/analytics/project",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "TASKS",
      link: "/analytics/tasks",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "DISTRIBUTIONS",
      link: "/analytics/distributions",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    }
  ] as MenuType[]
}